import { DirectoryBaseOrgInfo } from '@platform/client/schemas';
import { SubheaderPanel } from './SubheaderPanel';
import { DescriptionText } from './DescriptionText';
import MaxLengthContainer from './MaxLengthContainer';

export const OrgDescriptions = ({
  orgData,
  maxLength,
}: {
  orgData: DirectoryBaseOrgInfo;
  maxLength: number;
}) => {
  return (
    <MaxLengthContainer maxLength={maxLength}>
      {orgData.problemStatement.length > 0 && (
        <SubheaderPanel title='The Problem'>
          <DescriptionText html={orgData.problemStatement} />
        </SubheaderPanel>
      )}
      {orgData.solutionDescription.length > 0 && (
        <SubheaderPanel title="How we're solving it">
          <DescriptionText html={orgData.solutionDescription} />
        </SubheaderPanel>
      )}
    </MaxLengthContainer>
  );
};
